export const formatMoney = (amount, currency) =>
  `${currency || ""} ${Number(amount || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`.trim();

/* YYYY-MM-DD → DD/MM/YYYY, as on the printed job order. */
export const formatDate = (value) => {
  if (!value) return "-";
  const [year, month, day] = String(value).slice(0, 10).split("-");
  return year && month && day ? `${day}/${month}/${year}` : String(value);
};

const pad = (n) => String(n).padStart(2, "0");

/* Local calendar date (the reference used toISOString, which is a day off east/west of UTC around midnight). */
export const todayISO = (date = new Date()) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const truncate = (str, max) => (str.length > max ? `${str.slice(0, max)}...` : str);

export const initials = (name) =>
  (name || "Portal User")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

export const safeFilename = (value) => String(value || "").replace(/[^A-Za-z0-9_-]+/g, "_").replace(/^_+|_+$/g, "");

/* "14:30" / "14:30:00" → "2:30 PM"; anything else is returned as-is. */
export const formatTime12Hr = (value) => {
  if (!value) return "";
  const match = /^(\d{1,2}):(\d{2})/.exec(String(value).trim());
  if (!match) return String(value);
  const hours = parseInt(match[1], 10);
  return `${hours % 12 || 12}:${match[2]} ${hours >= 12 ? "PM" : "AM"}`;
};

/* DOTIZO_{Customer}_{JobNo}: the PDF file name and the browser's "Save as PDF" name when printing. */
export const jobDocTitle = (job) => {
  const customer = String(job.customer_name || "Customer").trim().replace(/[^a-zA-Z0-9]/g, "_").replace(/_+/g, "_");
  const jobNo = String(job.job_no || "JO-000").trim().replace(/[^a-zA-Z0-9_-]/g, "_");
  return `DOTIZO_${customer}_${jobNo}`;
};

/* "Sara", "Sara & Ali", "Sara, Ali +2" */
export const namesSummary = (people, max = 2) => {
  const names = (people || []).map((person) => person.name);
  if (names.length <= max) return names.join(" & ");
  return `${names.slice(0, max).join(", ")} +${names.length - max}`;
};

/*
 * Who a schedule item is with: on your own item, who you assigned it to; on
 * someone else's, who assigned it to you or (assignment switched off, items
 * shared with everyone) who added it. Job deadlines have no creator.
 */
export const assignmentLabel = (item) => {
  const assignees = item.assignees || [];
  if (item.can_edit) return assignees.length ? `Assigned to ${namesSummary(assignees)}` : "";
  if (!item.created_by) return "";
  return `${assignees.length ? "Assigned" : "Added"} by ${item.created_by.name}`;
};

/* A booking / meeting / task still pending after its day (the feed keeps overdue tasks listed). */
export const isOverdue = (item, today = todayISO()) => item.source === "event" && !item.completed && item.date < today;
